<div *ngIf="course$ | async as course">
    "{{course.courseTemplate.name}}" successfully completed
</div>